"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JetHost = void 0;
class JetHost {
    constructor(options) {
        this.osBuild = "unknown";
        this.deviceModel = "unknown";
        this.deviceModelFamily = "unknown";
        this.devicePhysicalModel = "unknown";
        this.deviceLocalizedModel = "unknown";
        this.clientIdentifier = "unknown";
        this.clientVersion = "unknown";
        this.platform = options.platform;
    }
    isOSAtLeast() {
        return false;
    }
}
exports.JetHost = JetHost;
